export default __webpack_public_path__ + "static/media/bookmark.ec573fbf.svg";